var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":_vm.transition}},[(_vm.visible)?_c('div',{ref:"overlay",staticClass:"a-overlay",class:[_vm.staticClass, _vm.className, _vm.subtle ? '-subtle' : ''],on:{"click":function($event){return _vm.$emit('click')}}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }